import classNames from "classnames";
import { FC, ReactNode } from "react";

const Chip: FC<{ title: ReactNode; icon: ReactNode; className?: string }> = ({ title, icon, className }) => {
  return (
    <div
      className={classNames(
        "bg-background-primary-lighter text-font-active flex w-full w-min items-center gap-1 whitespace-nowrap rounded-full px-4 py-1 text-sm font-medium outline outline-current",
        className,
      )}
    >
      <div>{icon}</div>
      <div>{title}</div>
    </div>
  );
};

export default Chip;
